import i18next from 'i18next';
import { SmsTypes } from 'infrastructure/enums';

export interface ISmsTypeItem {
  id: SmsTypes | null;
  name: string;
}

interface IProps {
  withAll?: boolean;
}

export const smsTypesDataSource = (props?: IProps): ISmsTypeItem[] => {
  const { withAll = false } = props ?? {};
  const dataSource: ISmsTypeItem[] = [
    {
      id: SmsTypes.Incoming,
      name: i18next.t('smsTypes.incoming'),
    },
    {
      id: SmsTypes.User,
      name: i18next.t('smsTypes.user'),
    },
    {
      id: SmsTypes.AdherenceAutomated,
      name: i18next.t('smsTypes.adherence-automated'),
    },
    {
      id: SmsTypes.AutomatedResponse,
      name: i18next.t('smsTypes.automated-response'),
    },

    {
      id: SmsTypes.Unknown,
      name: i18next.t('smsTypes.unknown'),
    },

    {
      id: SmsTypes.Campaign,
      name: i18next.t('smsTypes.campaign'),
    },
  ];

  if (withAll) {
    dataSource.unshift({
      id: null,
      name: i18next.t('controls.all'),
    });
  }

  return dataSource;
};
